module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ActionSidebarBrandingTitle":"Надпись \\"Made on Yourgood Widget\\""},"en":{"ActionSidebarBrandingTitle":"Inscription \\"Made on Yourgood Widget\\""}}')
  delete Component.options._Ctor
}
